const initialState = {
    isLoading: false,
};

export default initialState;
